// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trial-banner[data-v-7f858969]{position:fixed;bottom:2.5rem;right:1.25rem;z-index:2}@media(min-width:36rem){.trial-banner[data-v-7f858969]{right:3.125rem}}.tariff-name[data-v-7f858969]{color:#167ea2}.btn[data-v-7f858969]{width:100%}", ""]);
// Exports
module.exports = exports;
